module.exports = {
          srcSet: __webpack_public_path__ + "9c21bab47269282b46e5ac3533b4451d-120.png"+" 120w",
          images:[ {path: __webpack_public_path__ + "9c21bab47269282b46e5ac3533b4451d-120.png",width: 120,height: 8}],
          src: __webpack_public_path__ + "9c21bab47269282b46e5ac3533b4451d-120.png",
          toString:function(){return __webpack_public_path__ + "9c21bab47269282b46e5ac3533b4451d-120.png"},
          
          width: 120,
          height: 8
        }